import { change } from 'redux-form';
import {
    BASE_URL,
    RESEND_EMAIL_FIELD,
    RESEND_EMAIL_FORM_NAME,
    RESEND_EMAIL_PATH,
} from '../../../constants';
import {
    trackResendEmailCancel,
    trackResendEmailClick,
    trackResendEmailSubmit,
} from '../../eventAnalytics';
import { joinPath } from '@eventbrite/path-utils';
import { push } from 'react-router-redux';
import { getOrderId } from '../../../selectors/order';
import { updateOrderEmailAction } from '../actions';
import { showPurchaseConfirmation } from '../../purchaseConfirmation';
import { resendEmail as resendEmailApi } from '../../../api/order';

/**
 * Prefilling email input to resend the confirmation email with the email used in the order
 */
export const prefillResendEmailInput = () => (dispatch, getState) => {
    const {
        order: { email: orderEmail },
    } = getState();

    dispatch(
        change(RESEND_EMAIL_FORM_NAME, RESEND_EMAIL_FIELD, orderEmail, true),
    );
};

/**
 * There is an attempt to resend the order to another email, a form to enter the new email is shown.
 * A tracking action is triggered to save the user action.
 */
export const resendEmailAttempt = () => (dispatch) => {
    dispatch(trackResendEmailClick());

    return dispatch(push(joinPath(BASE_URL, RESEND_EMAIL_PATH)));
};

/**
 * The order is sent to the new email.
 * A tracking action is triggered to save the user action.
 */
export const resendEmail =
    ({ resendEmail: email }) =>
    async (dispatch, getState) => {
        const state = getState();
        const orderId = getOrderId(state);

        await resendEmailApi(orderId, email);
        await dispatch(updateOrderEmailAction({ email }));

        await dispatch(showPurchaseConfirmation());

        return dispatch(trackResendEmailSubmit());
    };

/**
 * The order is not sent to the new email and the user goes back to the status page.
 * A tracking action is triggered to save the user action.
 */
export const cancelResendEmail = () => (dispatch) => {
    dispatch(trackResendEmailCancel());

    return dispatch(showPurchaseConfirmation());
};
